var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"blue-hero",attrs:{"shrink":""}},[(_vm.stacked)?_c('div',{staticClass:"background-check"},[_c('BackgroundCheck',{staticClass:"hero-bg-check row-bg",attrs:{"color":"#25D7F8"}})],1):_vm._e(),_vm._v(" "),_c('v-row',{class:{
      'mx-auto content-container': true,
      'flex-column-reverse': _vm.reversed,
      'flex-row-reverse': _vm.flipped,
    },attrs:{"align-center":""}},[_c('v-col',{class:{
        'd-flex flex-column justify-center first-col': true,
        'pa-0 pl-4': _vm.$vuetify.breakpoint.mdAndUp,
        'py-8': _vm.padded,
        'mt-6': _vm.stacked && _vm.short,
      },attrs:{"cols":_vm.stacked ? 12 : 6,"sm":"6"}},[_vm._t("heading")],2),_vm._v(" "),_c('v-col',{class:{
        'pa-0 d-flex justify-center hero-image-container': true,
        'stacked mx-auto': _vm.stacked,
        'mb-n16': _vm.stacked && _vm.padded && _vm.reversed,
        'mt-n12': _vm.stacked && _vm.padded && !_vm.reversed,
        'py-8': _vm.padded,
      },attrs:{"cols":_vm.stacked ? 12 : 6,"sm":"6"}},[(!_vm.stacked)?_c('div',{staticClass:"background-check"},[_c('BackgroundCheck',{class:{ 'hero-bg-check': true, short: !!_vm.short },attrs:{"color":"#25D7F8"}})],1):_vm._e(),_vm._v(" "),(!_vm.padded)?_c('div',{class:{
          'place-holder': true,
          stacked: _vm.stacked,
        },style:(_vm.placeholderStyle)}):_vm._e(),_vm._v(" "),_vm._t("image")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }